import { createSelector } from 'reselect';
export var getState = function (state) { return state.aviaOrder; };
export var getAviaOrderExareInfo = createSelector(getState, function (aviaOrder) { return aviaOrder.exareInfo; });
export var getIsAutoModeAllowed = createSelector(getAviaOrderExareInfo, function (exareInfo) { return exareInfo.refundAutoMode; });
export var getAviaOrderTravellers = createSelector(getState, function (aviaOrder) { return aviaOrder.travellers; });
export var getCustomer = createSelector(getState, function (aviaOrder) { return aviaOrder.customer; });
